import { Box, Card, Grid, Typography, useTheme } from '@mui/material';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';

const CardTotalEstadoTk = ({titulo,total,vencidos,noVencidos,isDarkMode}) => {
    const theme = useTheme();
    const darkModeActive = isDarkMode !== undefined ? isDarkMode : theme.palette.mode === 'dark';

    return (
        <Card sx={{
            background: darkModeActive ? '#1F2A40 !important' : '#fff !important',
            padding: 2,
            borderRadius:5,
            boxShadow: darkModeActive ? '0 4px 20px rgba(0,0,0,0.3)' : '0 4px 20px rgba(0,0,0,0.1)'
        }}>
            <Box sx={{display: 'flex',alignItems: 'center'}}>
                <Box sx={{
                    borderWidth: 2,
                    borderStyle: 'dashed !important',
                    borderColor: darkModeActive ? '#64B5F6 !important' : '#1d5ae5 !important', 
                    width:45, 
                    height: 45,
                    border: 1,
                    borderRadius: 50, 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center'
                }}>
                    <ConfirmationNumberOutlinedIcon sx={{color: darkModeActive ? '#64B5F6' : '#1d5ae5',fontSize: 35}} />
                </Box>
                <Typography sx={{color: darkModeActive ? '#e0e0e0' : '#000',marginLeft: 2}} variant='h4'>{titulo}</Typography>
            </Box>
            <Grid container mt={3}>
                <Grid item xs={4} display='flex'>
                    <Typography sx={{color: darkModeActive ? '#fff' : '#000',fontWeight: 'bold',marginRight: 1}} variant='h3'>{total || '-'}</Typography>
                    <Typography
                        sx={{
                            fontWeight: 'bold',
                            color: darkModeActive ? '#a0a0a0' : '#74767f',
                            height:30, 
                            width: 100,
                            background: darkModeActive ? '#2d3a52' : '#e7e7e9',
                            display: 'flex', 
                            alignItems: 'center',
                            justifyContent: 'center', 
                            borderRadius:20
                        }}
                        component='div'
                    >
                        <Box fontWeight='bold' display='inline' sx={{fontSize: 20,color: darkModeActive ? '#a0a0a0' : '#74767f'}}>• </Box> Total
                    </Typography>
                </Grid>
                <Grid item xs={4} display='flex'>
                    <Typography sx={{color: darkModeActive ? '#fff' : '#000',fontWeight: 'bold',marginRight: 1}} variant='h3'>{noVencidos || '-'}</Typography>
                    <Typography
                        sx={{
                            fontWeight: 'bold',
                            color: '#018155',
                            height:30, 
                            width: 110,
                            background: darkModeActive ? '#1a3d2e' : '#E6F8F2',
                            display: 'flex', 
                            alignItems: 'center',
                            justifyContent: 'center', 
                            borderRadius:20
                        }}
                        component='div'
                    >
                        <Box fontWeight='bold' display='inline' sx={{fontSize: 20,color: '#018155'}}>• </Box> No Vencidos
                    </Typography>
                </Grid>
                <Grid item xs={4} display='flex'>
                    <Typography sx={{color: darkModeActive ? '#fff' : '#000',fontWeight: 'bold',marginRight: 1}} variant='h3'>{vencidos || '-'}</Typography>
                    <Typography
                        sx={{
                            fontWeight: 'bold',
                            color: '#9d0b0b',
                            height:30, 
                            width: 100,
                            background: darkModeActive ? '#3d1a1a' : '#fce7e7',
                            display: 'flex', 
                            alignItems: 'center',
                            justifyContent: 'center', 
                            borderRadius:20
                        }}
                        component='div'
                    >
                        <Box fontWeight='bold' display='inline' sx={{fontSize: 20,color: '#9d0b0b'}}>• </Box> Vencido
                    </Typography>
                </Grid>
            </Grid>
        </Card>
    )
}

export default CardTotalEstadoTk